import { useParams } from 'react-router-dom';
import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { Button } from '@/components/Button';
import { Card, CARD_TITLE } from '@/components/Card';
import { DocRow } from '@/components/DocRow';
import { DraftMarker } from '@/components/DraftMarker';
import { PageHeader } from '@/components/PageHeader';
import { FACULTIES, findFaculty } from '@/data/faculties';
import { NotFound } from './NotFound';

export function FacultyDetail() {
  const { slug } = useParams();
  const faculty = findFaculty(slug);
  if (!faculty) return <NotFound />;

  return (
    <>
      <PageHeader
        title={faculty.name}
        intro={faculty.desc}
        image={faculty.photo}
        bannerSize="tall"
        back={{ label: 'Courses & syllabi', to: '/courses' }}
      />
      <Container className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,380px),1fr))] items-start gap-8 pt-[clamp(32px,5vw,56px)] pb-[clamp(56px,7vw,96px)]">
        <Card as="section" aria-labelledby="h-syllabus">
          <h2 id="h-syllabus" className={CARD_TITLE}>Syllabus</h2>
          <ul className="m-0 list-none border-t border-rule p-0">
            <DocRow
              title={`${faculty.name} syllabus`}
              meta={faculty.syllabusUrl ? 'PDF · current version' : 'PDF · to be added'}
              href={faculty.syllabusUrl}
            />
          </ul>
          <DraftMarker className="mt-4">
            DRAFT · course list, duration and eligibility to be taken from the approved syllabus
          </DraftMarker>
          <p className="mt-5 mb-0 text-[1.125rem] leading-[1.65] text-ink-2">
            The syllabus lists every course in this faculty and what is examined in theory and practical papers. Students
            study at an affiliated institute and take ITES Open Merit Examinations at an approved exam centre.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button href="/centres">Find an institute</Button>
            <Button href="/examinations" variant="outline">Examination information</Button>
          </div>
        </Card>
        <Card as="section" aria-labelledby="h-others">
          <h2 id="h-others" className={CARD_TITLE}>Other faculties</h2>
          <ul className="m-0 list-none border-t border-rule p-0">
            {FACULTIES.filter((f) => f.slug !== faculty.slug).map((f) => (
              <li key={f.slug} className="border-b border-rule">
                <AppLink
                  href={`/courses/${f.slug}`}
                  className="flex items-baseline gap-3.5 py-[13px] font-semibold text-ink no-underline hover:text-teal-700"
                >
                  <span aria-hidden="true" className="font-mono text-[0.75rem] font-medium text-teal-700">{f.n}</span>
                  {f.name}
                </AppLink>
              </li>
            ))}
          </ul>
        </Card>
      </Container>
    </>
  );
}
